module.exports = __webpack_public_path__ + "img/zs2.70eab52e.jpg";